export enum Filters {
  All = 'all',
  Coming = 'coming',
  Finished = 'finished',
  InProgress = 'in_progress'
}
